import { MTextField, ResponsiveFormContainer } from "@app/components";

const ProcedimientosForm = () => {
  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          key={"codigo"}
          name={"codigo"}
          label={"Código"}
          type="text"
          fullWidth
          validation={{ required: `El campo código es requerido` }}
        />

        <MTextField
          key={"codop"}
          name={"codop"}
          label={"codop"}
          type="text"
          fullWidth
          validation={{ required: `El campo descripción es requerido` }}
        />
        <MTextField
          key={"numop"}
          name={"numop"}
          label={"numop"}
          type="text"
          fullWidth
          validation={{ required: `El campo codet es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default ProcedimientosForm;
